import { Stack } from 'expo-router';

export default function ProfileStructureLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
